<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-flex v-if="admin" xs12 mb-3>
        <h1 class="max">{{i18n('Contas favoritas')}}</h1>
        <FavoriteBankAccounts />
      </v-flex>
      <v-flex xs12 mb-3>
        <h1 class="max">{{i18n('Canais Bancários')}}</h1>
      </v-flex>
      <v-flex xs12 mb-3>
        <BankAccounts 
          :show_partner_facilita_bank_accounts="show_partner_facilita_bank_accounts" 
          :show_partner_external_bank_accounts="show_partner_external_bank_accounts"
          :show_facilita_bank_accounts="show_facilita_bank_accounts"
        />
      </v-flex>
    </v-container>
  </layout>
</template>

<script>

import LeftBarLayout from "../layouts/LeftBarLayout"
import BankAccounts from "../components/BankAccounts"
import FavoriteBankAccounts from "../components/FavoriteBankAccounts.vue"

export default {
  name: 'BankAccountsPage',
  components: {
    layout: LeftBarLayout,
    FavoriteBankAccounts,
    BankAccounts
  },
  data() {
    return {
      admin: false
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    }
  },
  computed: {
    show_partner_facilita_bank_accounts() {
      return !this.admin
    },
    show_partner_external_bank_accounts() {
      return !this.admin
    },
    show_facilita_bank_accounts() {
      return this.admin
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()
    this.admin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'

    let has_registered_company = this.$cookies.isKey('company_id') && this.$cookies.get('company_id') !== ''
    if (!has_registered_company) {
      this.$router.push('/')
      return
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/BankAccountsPage.vue